import React from 'react'
import PropTypes from 'prop-types'
import './text.css'

const DatenschutzSeite = (props) => {
  return (
    <div className={`text-container ${props.rootClassName}`}>
      <h3 className="text-thq-about-title-elm">Datenschutzerklärung</h3>
      <p className="text-thq-about-text-elm">
        <strong>Verantwortlicher</strong>
        <br />
        Stimme Georgiens <br />
        Kaiser-Joseph-Straße 172, 79098, Freiburg<br />
        info@stimmegeorgiens.de
        <br /><br />

        <strong>Allgemeine Informationen</strong>
        <br />
        Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare Person beziehen. Diese Datenschutzerklärung informiert über die Verarbeitung personenbezogener Daten auf unserer Website.
        <br /><br />

        <strong>Server-Logfiles</strong>
        <br />
        Beim Besuch unserer Website werden automatisch technische Daten wie IP-Adresse, Browsertyp, Datum/Uhrzeit des Zugriffs und angeforderte Seiten erfasst. Diese Daten werden nur zur Sicherstellung des Betriebs und zur Sicherheitsüberwachung verwendet und nach kurzer Zeit gelöscht.
        <br /><br />

        <strong>Cookies</strong>
        <br />
        Unsere Website verwendet Cookies, um die Nutzung zu erleichtern und bestimmte Funktionen zu ermöglichen. Einige Cookies sind technisch notwendig, andere dienen der Analyse oder Optimierung. Für nicht notwendige Cookies holen wir Ihre Einwilligung ein. Sie können Cookies jederzeit in Ihrem Browser deaktivieren.
        <br /><br />

        <strong>Kontaktformular</strong>
        <br />
        Wenn Sie unser Kontaktformular nutzen, erheben wir Name, E-Mail-Adresse und Ihre Nachricht, um Ihre Anfrage zu bearbeiten. Diese Daten werden ausschließlich für diesen Zweck genutzt und nach Bearbeitung gelöscht. Eine Weitergabe an Dritte erfolgt nur mit Ihrer Einwilligung oder wenn gesetzlich vorgeschrieben.
        <br /><br />

        <strong>Newsletter / Subscription</strong>
        <br />
        Wenn Sie unseren Newsletter abonnieren, erheben wir Name und E-Mail-Adresse. Die Anmeldung erfolgt freiwillig auf Grundlage Ihrer Einwilligung. Ihre Daten werden nur für den Versand des Newsletters verwendet und können jederzeit widerrufen werden. Nach Abmeldung werden Ihre Daten gelöscht, soweit keine gesetzlichen Aufbewahrungspflichten bestehen.
        <br /><br />

        <strong>Tracking & Analyse</strong>
        <br />
        Wir nutzen ggf. Tracking-Tools und Analyse-Dienste, um die Nutzung unserer Website zu verbessern. Dies erfolgt nur nach vorheriger Einwilligung (Opt-in). Die gesammelten Daten werden anonymisiert oder pseudonymisiert verarbeitet.
        <br /><br />

        <strong>Weitergabe an Dritte</strong>
        <br />
        Eine Weitergabe Ihrer Daten an Dritte erfolgt nur, soweit dies für den jeweiligen Zweck notwendig ist (z. B. Hosting, Newsletter-Versand, Analyse) oder gesetzlich vorgeschrieben ist.
        <br /><br />

        <strong>Speicherung und Löschung</strong>
        <br />
        Ihre personenbezogenen Daten werden nur so lange gespeichert, wie es für den jeweiligen Zweck notwendig ist oder gesetzliche Aufbewahrungspflichten bestehen. Danach werden die Daten gelöscht oder anonymisiert.
        <br /><br />

        <strong>Rechte der Betroffenen</strong>
        <br />
        Sie haben jederzeit folgende Rechte:
        <br />
        - Auskunft über Ihre gespeicherten Daten zu erhalten
        <br />
        - Berichtigung oder Löschung zu verlangen
        <br />
        - Einschränkung der Verarbeitung zu verlangen
        <br />
        - Widerspruch gegen die Verarbeitung einzulegen
        <br />
        - Ihre Einwilligung jederzeit zu widerrufen
        <br />
        - Beschwerde bei einer Datenschutzaufsichtsbehörde einzulegen
        <br />
        Für alle Anfragen kontaktieren Sie uns bitte unter <a href="mailto:info@stimmegeorgiens.de">info@stimmegeorgiens.de</a>.
        <br /><br />

        <strong>Sicherheit</strong>
        <br />
        Wir treffen technische und organisatorische Maßnahmen, um Ihre Daten vor Verlust, Missbrauch oder unbefugtem Zugriff zu schützen. Unsere Website verwendet eine sichere SSL/TLS-Verschlüsselung.
        <br /><br />

        <strong>Impressum</strong>
        <br />
        Bitte beachten Sie, dass ein vollständiges Impressum gemäß §5 TMG auf unserer Website verfügbar ist.
        <br /><br />

        <strong>Änderungen der Datenschutzerklärung</strong>
        <br />
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an gesetzliche Änderungen oder neue Dienste anzupassen. Die jeweils aktuelle Version finden Sie auf unserer Website.
      </p>
    </div>
  )
}

DatenschutzSeite.defaultProps = {
  rootClassName: '',
}

DatenschutzSeite.propTypes = {
  rootClassName: PropTypes.string,
}

export default DatenschutzSeite
